module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/course/labs/awsop/awsop-labs-def/awsop-labs-def.component.css
// module id = ./src/app/course/labs/awsop/awsop-labs-def/awsop-labs-def.component.css
// module chunks = main